import { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarDays } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

export function DateField({ value, onChange, fromDate, toDate, disabled, placeholder = "Select date", testid }) {
  const [open, setOpen] = useState(false);
  const selected = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className="belo-input text-left flex items-center justify-between">
          <span className={selected ? "text-slate-900" : "text-slate-400"}>{selected ? format(selected, "EEE, MMM d, yyyy") : placeholder}</span>
          <CalendarDays size={16} className="text-slate-400 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected || fromDate}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }}
          fromDate={fromDate}
          toDate={toDate}
          disabled={disabled}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}

export function DobField({ value, onChange, maxDate, testid }) {
  const [open, setOpen] = useState(false);
  const selected = value ? parseISO(value) : undefined;
  const thisYear = new Date().getFullYear();
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className="belo-input text-left flex items-center justify-between">
          <span className={selected ? "text-slate-900" : "text-slate-400"}>{selected ? format(selected, "MMM d, yyyy") : "Select your date of birth"}</span>
          <CalendarDays size={16} className="text-slate-400 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected || new Date(thisYear - 25, 0)}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }}
          captionLayout="dropdown-buttons"
          fromYear={1920}
          toYear={thisYear - 16}
          disabled={maxDate ? { after: maxDate } : undefined}
          classNames={{
            caption_label: "hidden",
            caption_dropdowns: "flex gap-2",
            dropdown: "border border-slate-200 rounded-lg px-2 py-1 text-sm bg-white outline-none focus:border-blue-500 cursor-pointer",
            vhidden: "hidden",
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
